import React from 'react'
import { ArrowDown, Plus } from 'react-feather'

import { cn } from '@/lib/utils'

export function LiquidityFlowSeparator({
  variant = 'plus',
  className,
}: {
  variant?: 'plus' | 'arrow-down'
  className?: string
}) {
  return (
    <div className={cn('flex justify-center py-1', className)}>
      {variant === 'arrow-down' ? (
        <ArrowDown size={16} className="text-muted-foreground" />
      ) : (
        <Plus size={16} className="text-muted-foreground" />
      )}
    </div>
  )
}
